import Vue from 'vue'

export default class SliderRange {
	constructor(title, max, stops) {
		this._store = Vue.observable({ slider: 0 })
		this._title = title
		this._max = max
		this._stops = stops.sort((a, b) => b.min - a.min)
	}

	get slider() {
		return this._store.slider
	}
	set slider(val) {
		this._store.slider = val
	}

	get value() {
		return Math.round(this._store.slider * this._max)
	}
	get stop() {
		const stop = this._stops.find(s => this.value >= s.min)
		return stop ? stop.data : null
	}
	get data() {
		return {
			title: this._title,
			count: this.value,
			stop: this.stop
		}
	}
}
